import Delete from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useTableFromFileId, useTables } from "../hook/table";
import { tableOrNotFoundAsTable } from "../types/table";
import { CopyClipboard } from "./copyClipboard";

export interface TableOptionsTableProps {
  fileIds: string[];
  onAdd?: (fileId: string) => Promise<any>;
  onRemove?: (fileId: string) => Promise<any>;
}

export const TableAddOptionsModal: React.FC<
  TableOptionsTableProps & {
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
  }
> = ({ fileIds, modalOpen, onAdd, setModalOpen }) => {
  const tablesMap = useTables();
  const addOptions = Object.values(tablesMap);

  return (
    <Modal open={modalOpen}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Paper
          elevation={7}
          sx={{
            padding: "2rem",
            minWidth: "80rem",
            gap: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Table Id</TableCell>
                <TableCell>File Id</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Add</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {addOptions.map((table, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{table?.["table-id"] ?? "Not Found!"}</TableCell>
                    <TableCell>{table?.["file-id"] ?? "Not Found!"}</TableCell>
                    <TableCell>{table?.name ?? "Not Found!"}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() => {
                          const fileId = table?.["file-id"];
                          if (!fileId) return;
                          if (!onAdd) return;
                          onAdd(fileId);
                          setModalOpen(false);
                        }}
                      >
                        Add
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
            }}
          >
            <Button
              onClick={() => {
                setModalOpen(false);
              }}
            >
              Close
            </Button>
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};

export const TableOptionsTable: React.FC<TableOptionsTableProps> = (props) => {
  const { fileIds } = props;
  const tableFromFileId = useTableFromFileId();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <TableAddOptionsModal
        {...props}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
      <Table>
        <TableHead>
          <TableCell>Table Id</TableCell>
          <TableCell>File Id</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Remove</TableCell>
        </TableHead>
        <TableBody>
          {fileIds.map((fileId) => {
            const tableOrNotFound = tableFromFileId(fileId);
            const table = tableOrNotFoundAsTable(tableOrNotFound);
            const tableId = table?.["table-id"];

            return (
              <TableRow key={fileId}>
                <TableCell>
                  <Button
                    disabled={true}
                    onClick={() => {
                      if (!tableId) return;
                      // navigateTable(tableId);
                    }}
                  >
                    {tableId}
                  </Button>
                  <CopyClipboard value={table?.["table-id"]!} />
                </TableCell>
                <TableCell>
                  {table?.["file-id"]}
                  <CopyClipboard value={table?.["file-id"]!} />
                </TableCell>
                <TableCell>{table?.["name"]}</TableCell>
                <TableCell>
                  <IconButton
                    disabled={true}
                    onClick={() => {
                      // console.log("REMOVING INPUT");
                    }}
                    color="primary"
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};
